import React, { PureComponent } from 'react';
import { Marker } from 'react-google-maps';

import { getSymbolUrl } from 'shared/helpers/map';
import { SYMBOL_TYPES, USER_MARKER_STYLES } from 'shared/constants/map';
import { toGoogleCoordinates } from 'shared/helpers/coordinates';
import { COLORS } from 'shared/constants/theme';

export default class MapUserMarker extends PureComponent {
  render() {
    const { coordinates } = this.props;
    if (!coordinates) {
      return false;
    }

    return (
      <Marker
        noRedraw
        icon={{
          ...USER_MARKER_STYLES,
          url: getSymbolUrl(SYMBOL_TYPES.USER, COLORS.denim)
        }}
        key="Shops_Map_User_Marker"
        position={toGoogleCoordinates(coordinates)}
      />
    );
  }
}
